import { render } from "./Digitalizzazione.vue?vue&type=template&id=56398792&scoped=true"
import script from "./Digitalizzazione.vue?vue&type=script&lang=js"
export * from "./Digitalizzazione.vue?vue&type=script&lang=js"

import "./Digitalizzazione.vue?vue&type=style&index=0&id=56398792&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56398792"]])

export default __exports__